import React, { createContext, useContext, useState } from 'react';

const DataContext = createContext();
export const useData = () => useContext(DataContext);

export const DataProvider = ({ children }) => {
  const [cachedData, setCachedData] = useState(() => {
    const stored = localStorage.getItem('cachedData');
    return stored
      ? JSON.parse(stored)
      : {
          courses: [],
          books: [],
          faqs: [],
          setting: {},
          services: [],
          events: [],
          collab: [],
          coursesDetails: {},
          lastFetched: null,
        };
  });

  const updateCachedData = (newData) => {
    const updated = { ...newData, lastFetched: Date.now() };
    setCachedData(updated);
    localStorage.setItem('cachedData', JSON.stringify(updated));
  };

  const clearCache = () => {
    const emptyCache = {
      courses: [],
      books: [],
      faqs: [],
      setting: {},
      services: [],
      events: [],
      collab: [],
      coursesDetails: {},
      lastFetched: null,
    };
    setCachedData(emptyCache);
    localStorage.removeItem('cachedData');
  };

  return (
    <DataContext.Provider value={{ cachedData, updateCachedData, clearCache }}>
      {children}
    </DataContext.Provider>
  );
};
